import React from 'react';
import {useFormik, FormikContext} from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff',
        height: 40,
        width: 200
    },
    wrapBlock: {
        padding: '10px 0', 
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    },
}))

const DatePicker = ({changeDate}) => {
    const classes = useStyles();
    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }
    const utc = new Date().getTime();
    const formik = useFormik({initialValues});

    return (
        <FormikContext.Provider value={formik}>
            <form>
                <div className={classes.wrapBlock}>
                    <div style={{display: 'flex', flexDirection:'column', alignItems: 'center'}}>
                        <div>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                    formik.setFieldValue('date_from', date.getTime());
                                    const date_from = isNaN(date.getTime()) ? 0 : date.getTime();
                                    const date_to = isNaN(formik.values.date_to) ? utc : formik.values.date_to;
                                    changeDate({date_from, date_to})
                                }}
                            />
                            <span style={{color: '#fff', padding: '0 5px'}}>&mdash;</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff', height: 40, width: 200}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value)
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }
                                    formik.setFieldValue('date_to', date.getTime());
                                    const date_from = isNaN(formik.values.date_from) ? 0 : formik.values.date_from;
                                    const date_to = isNaN(date.getTime()) ? utc : date.getTime();
                                    changeDate({date_from, date_to})
                                }}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </FormikContext.Provider>
    )
}

export default DatePicker;